<template>
  <div v-if="user && user.is_super_user && templates.length > 0" class="d-inline-block">
    <!-- Single template: show a simple button -->
    <template v-if="templates.length === 1">
      <b-btn @click="downloadTemplate(templates[0])"
             variant="outline-secondary"
             size="sm"
             :disabled="downloading">
        <fa :icon="templates[0].format === 'PDF' ? 'file-pdf' : 'file-word'"/>
        {{ templates[0].name }}
      </b-btn>
    </template>

    <!-- Multiple templates: show a dropdown -->
    <template v-else>
      <b-dropdown :text="$t('core.templates')" variant="outline-secondary" size="sm">
        <b-dropdown-item v-for="template in templates"
                         :key="template.id"
                         @click="downloadTemplate(template)">
          <fa :icon="template.format === 'PDF' ? 'file-pdf' : 'file-word'" class="mr-1"/>
          {{ template.name }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    contractId: {
      type: [Number, String],
      required: true
    }
  },

  data () {
    return {
      templates: [],
      downloading: false
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  watch: {
    contractId: {
      immediate: true,
      handler (newVal) {
        if (newVal && newVal !== 'new') {
          this.loadTemplates()
        }
      }
    }
  },

  methods: {
    loadTemplates () {
      axios.get(`/api/sandoz/contracts/${this.contractId}/templates`)
        .then((response) => {
          this.templates = response.data.data || []
        })
        .catch((error) => {
          console.error('Failed to load templates:', error)
        })
    },

    downloadTemplate (template) {
      this.downloading = true
      this.$root.$loading.start()

      const mimeType = template.format === 'PDF'
        ? 'application/pdf'
        : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

      const extension = template.format === 'PDF' ? '.pdf' : '.docx'

      axios.get(`/api/sandoz/contracts/${this.contractId}/templates/${template.id}/download`, {
        responseType: 'arraybuffer'
      })
        .then((response) => {
          require('downloadjs')(
            response.data,
            template.name + extension,
            mimeType
          )
          this.$root.$loading.finish()
          this.downloading = false
        })
        .catch((error) => {
          this.$root.$loading.finish()
          this.downloading = false
          console.error('Template download failed:', error)
        })
    }
  }
}
</script>
